export const mapClickListener = (google, callback) =>
  (_, clickEvent, coordinates) => {
    const geocoder = new google.maps.Geocoder();
    const lat = coordinates.latLng.lat();
    const lng = coordinates.latLng.lng();
    const latLng = new google.maps.LatLng(lat, lng);

    geocoder.geocode(
      { 'latLng': latLng },
      (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK)
          return alert('Geocoder failed due to: ' + status);

        const result = results[1];

        if (!result) return alert('No results found');

        const countyIndex = result.address_components
          .findIndex( ac => (
            ac.long_name.includes('County') ||  
            ac.long_name.includes('Puerto Rico')
          ));

        if (countyIndex === -1) return;

        // const { long_name: county } = result.address_components[countyIndex];
        // const { long_name: msa } = countyIndex !== 0 ? result.address_components[countyIndex - 1] : { long_name: '-' };
        const place = {
          formatted_address: result.formatted_address,
          lat,
          lng,
          // county,
          // msa
        };

        callback(place);
      }
    );
  };
